import { DropdownOptionsKey } from "@rms-types/modules/dropdown/types";
import { uniqBy } from "lodash";

import { DropdownOption, DropdownResponse } from "@/features/dropdown/api";

export function generateDynamicOptions(dynamicOptions: DropdownOptionsKey[], dropDownItems: DropdownResponse) {
  const mergedDropDownItems: DropdownOption[] = [];

  dynamicOptions.forEach((itemCategory) => {
    if (dropDownItems[itemCategory]) mergedDropDownItems.push(...dropDownItems[itemCategory]);
  });

  return uniqBy(mergedDropDownItems, "value");
}
